import React from "react";

import { getPreviewFramePrintFontSize } from "@/utils/qrEditorHelper";

import { QRFRameToPrintProps } from "../types";

import { uriText } from "./uri";

import "../styles.scss";

export const ShoppingbagFrameToDownload = (
  props: QRFRameToPrintProps
): React.SVGProps<SVGSVGElement> => {
  const {
    text,
    textColor,
    frameColor,
    frameBackgroundColor,
    height = 1200,
    qrSvg,
    width = 900,
  } = props;

  const fontSize = getPreviewFramePrintFontSize(text?.length);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none">
      <style>
        {`
              @font-face {
                font-family: 'Nunito Sans';
                src: url(${uriText});
                font-weight: bold
              }
            `}
      </style>
      <g id="surface1">
        <path
          fillRule="nonzero"
          fill="white"
          fillOpacity="1"
          strokeWidth="1"
          stroke="#BFBFBF"
          d="M 7.999875 0.5 L 88.000125 0.5 C 92.142 0.5 95.500125 3.857839 95.500125 8 L 95.500125 120 C 95.500125 124.142161 92.142 127.5 88.000125 127.5 L 7.999875 127.5 C 3.858 127.5 0.499875 124.142161 0.499875 120 L 0.499875 8 C 0.499875 3.857839 3.858 0.5 7.999875 0.5 Z M 7.999875 0.5 "
          transform="matrix(10.416667,0,0,10.414062,0,0)"
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 384.875 125.296875 C 459.566406 124.410156 534.101562 125.320312 608.476562 128.019531 C 629.609375 148.34375 650.078125 169.21875 669.878906 190.644531 C 670.792969 234.207031 671.097656 277.769531 670.792969 321.339844 C 717.839844 321.035156 764.878906 321.339844 811.917969 322.246094 C 816.925781 322.96875 820.285156 325.691406 822 330.414062 C 823.222656 537.347656 823.222656 744.28125 822 951.214844 C 816.988281 970.097656 805.074219 982.503906 786.261719 988.429688 C 592.59375 989.640625 398.925781 989.640625 205.261719 988.429688 C 187.59375 984.242188 175.679688 973.65625 169.519531 956.660156 C 166.480469 747.992188 165.867188 539.242188 167.6875 330.414062 C 169.402344 325.691406 172.761719 322.96875 177.769531 322.246094 C 224.808594 321.339844 271.847656 321.035156 318.894531 321.339844 C 318.585938 277.769531 318.894531 234.207031 319.808594 190.644531 C 340.640625 167.894531 362.332031 146.113281 384.875 125.296875 Z M 403.203125 152.527344 C 464.296875 152.527344 525.390625 152.527344 586.484375 152.527344 C 586.484375 162.8125 586.484375 173.097656 586.484375 183.382812 C 525.390625 183.382812 464.296875 183.382812 403.203125 183.382812 C 403.203125 173.097656 403.203125 162.8125 403.203125 152.527344 Z M 612.144531 170.675781 C 622.464844 179.992188 632.542969 189.671875 642.382812 199.722656 C 643.300781 240.253906 643.605469 280.796875 643.300781 321.339844 C 632.914062 321.339844 622.53125 321.339844 612.144531 321.339844 C 612.144531 271.117188 612.144531 220.898438 612.144531 170.675781 Z M 373.878906 172.492188 C 375.707031 221.796875 376.316406 271.414062 375.710938 321.339844 C 365.324219 321.339844 354.941406 321.339844 344.554688 321.339844 C 344.246094 281.398438 344.554688 241.464844 345.46875 201.535156 C 355.3125 192.09375 364.78125 182.414062 373.878906 172.492188 Z M 403.203125 208.796875 C 464.296875 208.796875 525.390625 208.796875 586.484375 208.796875 C 586.484375 246.917969 586.484375 285.035156 586.484375 323.15625 C 525.386719 322.886719 464.292969 322.277344 403.203125 321.339844 C 403.203125 283.824219 403.203125 246.3125 403.203125 208.796875 Z M 403.203125 208.796875 "
        />

        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameBackgroundColor}
          d="M 208.332031 374.90625 L 781.25 374.90625 L 781.25 874.78125 C 781.25 909.289062 753.269531 937.265625 718.75 937.265625 L 270.832031 937.265625 C 236.316406 937.265625 208.332031 909.289062 208.332031 874.78125 Z M 208.332031 374.90625 "
        />

        <g
          stroke="null"
          transform="matrix(6.2212 0 0 6.2212 0 -55)"
          id="svg_485">
          <g
            dangerouslySetInnerHTML={{ __html: qrSvg }}
            stroke="null"
            id="svg_486"></g>
        </g>
        <text
          x="500"
          y="1120.3999700784689"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
          fontFamily="Nunito Sans"
          style={{ fontSize }}>
          {text}
        </text>
      </g>
    </svg>
  );
};
